export default function syncTransatcion(syncPromise) {
  this.error = null
  this.isSaving = true
  return syncPromise
    .then(() => {
      this.isSaving = false
      this.handleClose()
    })
    .catch((error) => {
      this.error = error
      this.isSaving = false
    })
}



// WEBPACK FOOTER //
// ./src/shared/syncTransaction.js